import userMixin from "@/components/mixins/userMixin";
import {getJsonCookie} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";

/**
 * Mark guest-purchased galleries as purchased (via cookie check).
 * Gallery content is NOT merged into user.photos/videos — it is displayed
 * separately via ModalPrivateGalleryContentsComponent (matching Nuxt behavior).
 */
async function fetchUserPrivateGalleriesPhotos(ignoreSetLoader = false) {
    const isEscortProfile = this.hasRole(this.user, constants.user_role.OFFERING_SERVICES);
    if (!this.user || !isEscortProfile) {
        return;
    }

    const isGuestOrPunter = !this.isLoggedIn || this.isPunter;
    if (!isGuestOrPunter && !this.isUserAdmin) {
        return
    }

    if (!ignoreSetLoader) {
        this.isLoadingPrivateGalleries = true;
    }

    const galleries = _.get(this.user, 'galleries', []);

    const purchasedGalleries = getJsonCookie(CookiesEnum.PURCHASED_GUEST_GALLERIES);
    const purchasedGalleriesAreSet = purchasedGalleries && Array.isArray(purchasedGalleries);

    if (purchasedGalleriesAreSet) {
        galleries.forEach((gallery) => {
            if (gallery.purchased) {
                return;
            }

            const purchasedGallery = purchasedGalleries.find(item => item.galleryId === gallery.id);
            if (purchasedGallery) {
                gallery.purchased = true;
            }
        });
    }

    this.$forceUpdate();

    if (!ignoreSetLoader) {
        this.isLoadingPrivateGalleries = false;
    }
}

export default {
    methods: {
        fetchUserPrivateGalleriesPhotos,
    },
    mixins: [userMixin],
}
